import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Inject,
  ViewChild,
} from '@angular/core';

import { ConnectedMediaRemoteService } from '../../services/connected-media-remote/connected-media-remote.service';
import { CONNECTED_PLAYER_SRC } from '../../tokens/connected-player-src.token';
import { CONNECTED_PLAYER_VOLUME } from '../../tokens/connected-player-volume.token';

@Component({
  selector: 'bm-connected-audio-player',
  templateUrl: 'connected-audio-player.component.html',
  styleUrls: ['connected-audio-player.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
/**
 * Connected audio player. Created by a ComponentPortal
 */
export class ConnectedAudioPlayerComponent {
  public src: string;
  public volume: number;

  public get duration() {
    if (this._audioElement && this._audioElement.nativeElement) {
      return this._audioElement.nativeElement.duration;
    }
    return 0;
  }

  public get currentTime() {
    if (this._audioElement && this._audioElement.nativeElement) {
      return this._audioElement.nativeElement.currentTime;
    }
    return 0;
  }

  @ViewChild('audioElement', { read: ElementRef, static: true })
  private _audioElement!: ElementRef<HTMLAudioElement>;

  constructor(
    @Inject(CONNECTED_PLAYER_SRC) src: string,
    @Inject(CONNECTED_PLAYER_VOLUME) volume: number,
    private _cdr: ChangeDetectorRef,
    private _elementRef: ElementRef,
    private _remote: ConnectedMediaRemoteService,
  ) {
    this.src = src;
    this.volume = volume;
  }

  @HostListener('document:click', ['$event'])
  public onDocumentClick(e: MouseEvent) {
    if (this._remote.isOpen() && !this._audioElement.nativeElement.paused) {
      let parent: HTMLElement = e.target as HTMLElement;
      while (
        parent &&
        parent.tagName !== 'BODY' &&
        parent !== this._elementRef.nativeElement
      ) {
        parent = parent.parentElement as HTMLElement;
      }
      if (parent !== this._elementRef.nativeElement) {
        this._remote.close();
      }
    }
  }

  @HostListener('document:keydown', ['$event'])
  public onDocumentKeydown(e: KeyboardEvent) {
    if (
      this._remote.isOpen() &&
      !this._audioElement.nativeElement.paused &&
      e.key === 'Escape'
    ) {
      this._remote.close();
    }
  }

  public onSliderSeek($event: number) {
    if (this._audioElement) {
      this._audioElement.nativeElement.currentTime = $event;
    }
  }

  public onTimeupdate() {
    this._cdr.markForCheck();
  }

  public onMediaEnded() {
    this._remote.close();
  }

  public close(e: Event) {
    e.preventDefault();
    this._remote.close();
  }
}
